import { Outlet } from 'react-router-dom';
import Layout from '../components/Layout';
import DraftPostsBubble from '../components/DraftPostsBubble';
import useGlobalPollingErrorListener from '../hooks/useGlobalPollingErrorListener';

const AppLayout = () => {
  // Listen for global polling errors and display notifications
  useGlobalPollingErrorListener();

  return (
    <Layout>
      <Outlet />
      <DraftPostsBubble />
    </Layout>
  );
};

export default AppLayout;
